import ZeissButton from '@components/button';
import { ROLE_KEYS_MAP } from '@constants';
import { DataFlagEnum } from '@views/pages/AnnouncementList/announcement';
import { ShowSalesModalStatusEnum } from '@views/pages/AnnouncementList/tool';
import { Space } from 'antd';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import './index.scss';
import { AnnFooterPopup } from './Popup/annFooterPopup';
interface PropsTs {
  noticeCode?: string;
  details?: any;
  getAnnInfo: () => void;
  checkNeedOperation: () => any;
  checkFirstNotice: (fn: () => void) => any;
  isDealerSales: boolean;
}
export const useFooter = ({
  noticeCode,
  details,
  getAnnInfo,
  checkNeedOperation,
  isDealerSales,
  checkFirstNotice
}: PropsTs) => {
  const [searchParams] = useSearchParams();
  const isShowSalesModal = `${
    searchParams.get('isShowSalesModal') || ShowSalesModalStatusEnum.HIDE
  }`;

  const [repeatOpen, setRepeatOpen] = useState(false);
  const [actionId, useActionId] = useState(-1); //3:转销售 2:转Sector同事 5:不相关 6:重复
  const { userInfo } = JSON.parse(
    localStorage.getItem('recoil-persist') || '{}'
  );
  const isDealer = userInfo?.roleKeys === ROLE_KEYS_MAP.dealer;

  useEffect(() => {
    if (
      isShowSalesModal &&
      isShowSalesModal === ShowSalesModalStatusEnum.SHOW
    ) {
      handleDisplayRepeatPopup(3, false);
    }
  }, []);

  const handleDisplayRepeatPopup = async (
    action: number,
    isValidate = true
  ) => {
    if (isValidate) {
      const isNeedOperation = await checkNeedOperation?.();
      if (!isNeedOperation) return;
    }
    if ((action === 5 || action === 6) && details?.groups?.length > 0) {
      checkFirstNotice(() => {
        setRepeatOpen(true);
        useActionId(action);
      });
    } else {
      setRepeatOpen(true);
      useActionId(action);
    }
  };

  const calcBtnWidth = () => {
    if (isDealerSales) {
      return 309;
    } else if (isDealer) {
      return 245;
    } else {
      return 200;
    }
  };
  const annFooterComponent = (
    <Space size={'middle'} className="pc-footer-position">
      {!isDealerSales && !isDealer && (
        <>
          <ZeissButton
            type="primary"
            className="pc-footer-btn"
            onClick={() => handleDisplayRepeatPopup(3)}
          >
            给销售
          </ZeissButton>
          {userInfo?.roleKeys === 'admin' &&
          details.dataFlag === DataFlagEnum.dealer ? (
            ''
          ) : (
            <ZeissButton
              type="primary"
              className="pc-footer-btn pc-footer-btn-transfer"
              onClick={() => handleDisplayRepeatPopup(2)}
            >
              转交给{userInfo?.roleKeys === 'admin' ? 'Sector' : '同事'}
            </ZeissButton>
          )}
        </>
      )}

      <ZeissButton
        danger
        className="pc-footer-btn"
        style={{
          width: calcBtnWidth()
        }}
        onClick={() => handleDisplayRepeatPopup(5)}
      >
        整个公告不相关
      </ZeissButton>

      <ZeissButton
        type="primary"
        className="pc-footer-btn pc-footer-btn-repeat"
        style={{
          width: calcBtnWidth()
        }}
        onClick={() => handleDisplayRepeatPopup(6)}
      >
        整个公告重复
      </ZeissButton>
      <AnnFooterPopup
        getAnnInfo={getAnnInfo}
        details={details}
        noticeCode={noticeCode}
        actionId={actionId}
        open={repeatOpen}
        setOpen={setRepeatOpen}
        isAnnouncement={true}
        isDispatchAll={true}
      />
    </Space>
  );
  return {
    annFooterComponent
  };
};
